import React from 'react';
import { Icon } from './Icon.js';
export const IconPaperPlane3 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12 13L12 18.5L12 18", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M11.9999 3.00003L21.1923 20.6777L20.8387 21.0313L11.9999 18.5564L3.1611 21.0313L2.80758 20.6777L11.9999 3.00003Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconPaperPlane3.js.map